import React, { Component } from "react";
import SendScheduleButton from "./SendScheduleButton";
import { Event } from "../Tracking";

export default class extends Component {
  state = {
    status: "",
    hasFailed: false
  };

  handleClick = status => {
    this.setState({ status: status, hasFailed: false });
    Event("Commissioning Event", "Complete Commissioning", "(not set)");
  };

  handleStatusChange = status => {
    this.setState({ status: status });
  };

  handleSuccess = status => {
    this.setState({ status: status, hasFailed: false });

    this.props.onSuccess(status);
  };

  handleFail = status => {
    this.setState({ status: status, hasFailed: true });
  };

  render() {
    return (
      <SendScheduleButton
        {...this.props}
        status={this.state.status}
        onStatusChange={this.handleStatusChange}
        hasFailed={this.state.hasFailed}
        onSuccess={this.handleSuccess}
        onFail={this.handleFail}
        onClick={this.handleClick}
      />
    );
  }
}
